import React from 'react';

export const TemplateShare = () => {
  return <div>TemplateShare</div>;
};
